import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { BaseView } from '@/components/base'
import { Avatar } from './components/Avatar'
import { Label } from './components/Label'
import { useGetMe } from '@/domain'
import { useUserStore } from '@/store'

export const Profile: React.FC = () => {
  const navigate = useNavigate()

  const { isLoading, isFetching } = useGetMe()
  const userAuthenticated = useUserStore((state) => state.userAuthenticated)

  const isLoadingData = isLoading || isFetching

  const handleProfilePress = () => {
    navigate('/profile/profile-settings')
  }

  useEffect(() => {
    if (!isLoadingData && userAuthenticated && !userAuthenticated.username) {
      navigate('/setup-profile')
    }
  }, [isLoadingData, userAuthenticated, navigate])

  if (!isLoadingData && userAuthenticated && !userAuthenticated.username) {
    return null
  }

  return (
    <BaseView
      row
      align="center"
      gap={12}
      style={{
        cursor: 'pointer',
      }}
      onClick={handleProfilePress}
    >
      <Avatar
        uri={userAuthenticated?.avatar_path}
        skeletonActive={isLoadingData}
        firstName={
          userAuthenticated?.first_name || userAuthenticated?.username || 'U'
        }
      />

      {(userAuthenticated?.first_name || userAuthenticated?.username) && (
        <Label
          type="cardTitle"
          skeletonActive={isLoadingData}
          skeletonWidth={100}
        >
          {userAuthenticated.first_name || userAuthenticated.username || 'User'}
        </Label>
      )}
    </BaseView>
  )
}
